var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkreis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "skreis",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_640",
    "data-name": "Pfad 640",
    d: "M113.7,75.5a36.11,36.11,0,0,1-.7,7.3,29.584,29.584,0,0,1-1.7,6,39.875,39.875,0,0,1-8.1,13.2,12.1,12.1,0,0,1-1.6,1.6.1.1,0,0,0-.1.1c-.4.4-.9.8-1.3,1.2h0c-.5.4-.9.8-1.4,1.2h0c-.5.4-1,.7-1.5,1.1h0a14.629,14.629,0,0,1-1.3.9,9.13,9.13,0,0,1-1.3.8,4.129,4.129,0,0,0-1.1.7c-1,.5-1.9,1-2.9,1.5-.3.1-.6.3-.9.4-.1,0-.1,0-.1.1a.367.367,0,0,1-.3.1,5.638,5.638,0,0,1-1.2.4l-.5.2c-.4.1-.8.3-1.1.4h-.1c-.4.1-.9.3-1.3.4l-2.4.6c-.2,0-.4.1-.6.1a5.853,5.853,0,0,1-1.3.2h0c-.5.1-1,.1-1.4.2a7.084,7.084,0,0,1-1.4.1h0c-1,.1-2,.1-3,.1A39.052,39.052,0,0,1,38.6,89.1,35.847,35.847,0,0,1,37,83.5a38.952,38.952,0,0,1,76.2-16.2c.2,2.8.5,5.5.5,8.2Z",
    fill: "#4d9046",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_643",
    "data-name": "Pfad 643",
    d: "M100.3,85.9c0,9.4-9.2,20.4-24.6,20.4a39.355,39.355,0,0,1-23.9-8.7V85.3A30.571,30.571,0,0,0,75.7,98.4c5.8,0,10.4-3.3,10.4-6.8,0-13.3-34.9-5.1-34.9-28,0-12,11.8-18.5,22.3-18.5a37.485,37.485,0,0,1,23,7.7V63A32.415,32.415,0,0,0,73.3,52c-5.4,0-8.5,2.9-8.5,6.3.1,14.2,35.5,4.2,35.5,27.6Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_644",
    "data-name": "Pfad 644",
    d: "M113.7,75.5a36.11,36.11,0,0,1-.7,7.3,29.584,29.584,0,0,1-1.7,6,39.875,39.875,0,0,1-8.1,13.2,12.1,12.1,0,0,1-1.6,1.6.1.1,0,0,0-.1.1c-.4.4-.9.8-1.3,1.2h0c-.5.4-.9.8-1.4,1.2h0c-.5.4-1,.7-1.5,1.1h0a14.629,14.629,0,0,1-1.3.9,9.13,9.13,0,0,1-1.3.8,4.129,4.129,0,0,0-1.1.7c-1,.5-1.9,1-2.9,1.5-.3.1-.6.3-.9.4h-30A38.987,38.987,0,0,1,38.3,89.2a35.847,35.847,0,0,1-1.6-5.6,38.952,38.952,0,0,1,76.2-16.2A44.473,44.473,0,0,1,113.7,75.5Z",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_67",
    "data-name": "Rechteck 67",
    width: 150,
    height: 150,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkreis);
export default __webpack_public_path__ + "static/media/skreis.f010530d375af4fb0a38bac00e4a18e5.svg";
export { ForwardRef as ReactComponent };